import { ReportHandler } from 'web-vitals';

/**
 * Reports Core Web Vitals metrics which are critical for SEO
 * Google uses these metrics as ranking signals in their algorithm
 * Monitoring these helps improve user experience and search rankings
 */
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
        // Cumulative Layout Shift (visual stability)
        getCLS(onPerfEntry);
        // First Input Delay (interactivity)
        getFID(onPerfEntry);
        // First Contentful Paint
        getFCP(onPerfEntry);
        // Largest Contentful Paint (loading performance)
        getLCP(onPerfEntry);
        // Time to First Byte (server response time)
        getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
